<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-10 offset-lg-1 mt-4">
                    <v-row class="row row border-bottom-2 pb-4 mb-5">
                        <v-col class="col-12 col-md-7">
                            <h2>Kasboekje</h2>
                            <p class="intro">
                                <slot name="introductionText"></slot>
                            </p>
                        </v-col>
                        <v-col class="col-12 col-md-5">
                            <h2>Overzicht</h2>
                            <p class="intro">
                                Totaal inkomsten:
                                <span class="font-family--header">
                                    € {{ cashbookParsed.totalEarnings }}
                                </span>
                            </p>
                            <div class="graphic-circle">
                                <svg
                                    viewBox="0 0 36 36"
                                    class="circular-chart green"
                                >
                                    <path
                                        class="circle-bg"
                                        d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <path
                                        class="circle"
                                        :stroke-dasharray="dashArray"
                                        d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <text
                                        x="18"
                                        y="20.35"
                                        class="graphic-circle__title"
                                    >
                                        Restantbudget
                                    </text>
                                    <text
                                        x="18"
                                        y="20.35"
                                        class="graphic-circle__text"
                                    >
                                        € {{ cashbookParsed.totalRemainder }}
                                    </text>
                                </svg>
                            </div>
                        </v-col>
                    </v-row>
                    <div id="cashbook" class="cashbook">
                        <v-app id="cashbook-app">
                            <v-row>
                                <v-col
                                    class="col-12 col-md-6 processing-container"
                                >
                                    <div class="row">
                                        <h2
                                            ref="ledgerTitle"
                                            class="pb-4 mb-4 col-12 col-sm-6"
                                        >
                                            Inkomsten
                                        </h2>
                                        <h3
                                            class="
                                            h4 text-right mt-4 color--blue-7 col-12 col-sm-6
                                            "
                                        >
                                            Totaal budget: €
                                            {{ cashbookParsed.totalEarnings }}
                                        </h3>
                                    </div>
                                    <div
                                        :class="{
                                            processing: isProcessing
                                        }"
                                    >
                                        <spinner v-if="isProcessing" />
                                        <v-data-table
                                            :headers="headers"
                                            :items="cashbookParsed.earnings"
                                            class="elevation-1"
                                            :items-per-page="itemsPerPage"
                                            :page="earningsPage"
                                        >
                                            <template
                                                v-slot:item.description="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.description
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    {{ props.item.description }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .description
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template
                                                v-slot:item.amount="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.amount
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    € {{ props.item.amount }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .amount
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template
                                                v-slot:item.instance="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.instance
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    {{ props.item.instance }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .instance
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template v-slot:item.trash="props">
                                                <button
                                                    :disabled="isProcessing"
                                                    class="btn-trash"
                                                    @click.prevent="
                                                        deleteIncomeComponent(
                                                            props.item
                                                        )
                                                    "
                                                >
                                                    <span
                                                        class="font-family--header inactive"
                                                    >
                                                        verwijderen
                                                        <i
                                                            class="ml-1 fas fa-trash-alt"
                                                        ></i>
                                                    </span>
                                                </button>
                                            </template>
                                        </v-data-table>
                                        <v-pagination
                                            v-if="earningsPagesCount > 1"
                                            v-model="earningsPage"
                                            class="cashbook-pagination"
                                            :length="earningsPagesCount"
                                            circle
                                            @input="goToNextEarningsPage"
                                        ></v-pagination>
                                        <div class="col-12 text-right pr-0">
                                            <button
                                                :disabled="isProcessing"
                                                class="btn btn--medium btn--blue-7 ml-2"
                                                @click.prevent="
                                                    addIncomeComponent
                                                "
                                            >
                                                <span>
                                                    Toevoegen
                                                    <i
                                                        class="fas fa-plus ml-2"
                                                    ></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col class="col-12 col-md-6">
                                    <div class="row">
                                        <h2
                                            ref="expensesTitle"
                                            class="pb-4 mb-4 col-12 col-sm-6"
                                        >
                                            Uitgaven
                                        </h2>
                                        <h3
                                            class="h4 text-right mt-4 color--blue-7 col-12 col-sm-6"
                                        >
                                            Totaal uitgaven: €
                                            {{ cashbookParsed.totalExpenses }}
                                        </h3>
                                    </div>
                                    <div
                                        :class="{
                                            processing: isProcessing
                                        }"
                                    >
                                        <spinner v-if="isProcessing" />

                                        <v-data-table
                                            :headers="headers"
                                            :items="cashbookParsed.expenses"
                                            class="elevation-1"
                                            :items-per-page="itemsPerPage"
                                            :page="expensesPage"
                                        >
                                            <template
                                                v-slot:item.description="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.description
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    {{ props.item.description }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .description
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template
                                                v-slot:item.amount="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.amount
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    € {{ props.item.amount }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .amount
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template
                                                v-slot:item.instance="props"
                                            >
                                                <v-edit-dialog
                                                    :return-value.sync="
                                                        props.item.instance
                                                    "
                                                    large
                                                    persistent
                                                    save-text="Opslaan"
                                                    cancel-text="Annuleren"
                                                    @save="save"
                                                    @cancel="cancel"
                                                    @open="open"
                                                    @close="close"
                                                >
                                                    {{ props.item.instance }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                            v-model="
                                                                props.item
                                                                    .instance
                                                            "
                                                            label="Bewerken"
                                                            single-line
                                                            counter
                                                        ></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template v-slot:item.trash="props">
                                                <button
                                                    :disabled="isProcessing"
                                                    class="btn-trash pr-2"
                                                    @click.prevent="
                                                        deleteExpenseComponent(
                                                            props.item
                                                        )
                                                    "
                                                >
                                                    <span
                                                        class="font-family--header inactive"
                                                    >
                                                        verwijderen
                                                        <i
                                                            class="ml-1 fas fa-trash-alt"
                                                        ></i>
                                                    </span>
                                                </button>
                                            </template>
                                        </v-data-table>
                                        <v-pagination
                                            v-if="expensesPagesCount > 1"
                                            v-model="expensesPage"
                                            class="cashbook-pagination"
                                            :length="expensesPagesCount"
                                            circle
                                            @input="goToNextExpensesPage"
                                        ></v-pagination>
                                    </div>

                                    <div class="col-12 text-right pr-0">
                                        <button
                                            :disabled="isProcessing"
                                            class="btn btn--medium btn--blue-7 ml-2"
                                            @click.prevent="addExpenseComponent"
                                        >
                                            <span>
                                                Toevoegen
                                                <i class="fas fa-plus ml-2"></i>
                                            </span>
                                        </button>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-app>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vuetify from 'vuetify';
import axios from 'axios';
import spinner from '@/components/spinner';

export default {
    vuetify: new Vuetify(),
    components: {
        spinner
    },
    props: {
        cashbook: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            watchTrigger: false,
            totalEarnings: 0,
            totalExpenses: 0,
            totalRemainder: 0,
            headers: [
                { text: 'Titel', value: 'description' },
                { text: 'Bedrag', value: 'amount' },
                { text: 'Aanbieder', value: 'instance' },
                { text: '', value: 'trash' }
            ],
            cashbookParsed: {},
            itemsPerPage: 10,
            expensesPage: 1,
            earningsPage: 1,
            isProcessing: false
        };
    },
    computed: {
        dashArray() {
            return this.cashbookParsed.remainderPercentage + ', 100';
        },
        expensesPagesCount() {
            return Math.ceil(
                this.cashbookParsed.expenses.length / this.itemsPerPage
            );
        },
        earningsPagesCount() {
            return Math.ceil(
                this.cashbookParsed.earnings.length / this.itemsPerPage
            );
        }
    },
    mounted() {},
    created() {
        this.cashbookParsed = JSON.parse(this.cashbook);
        this.watchTrigger = true;
    },
    methods: {
        goToNextEarningsPage(page) {
            this.$refs.ledgerTitle.scrollIntoView({
                behavior: 'smooth'
            });
            this.earningsPage = page;
        },
        goToNextExpensesPage(page) {
            this.$refs.expensesTitle.scrollIntoView({
                behavior: 'smooth'
            });
            this.expensesPage = page;
        },
        addIncomeComponent() {
            this.cashbookParsed.earnings.push({
                description: 'voeg omschrijving toe',
                amount: 0,
                instance: 'voeg instantie/aanbieder toe'
            });
            this.watchTrigger = true;
            this.updateCashBook();
            return;
        },
        addExpenseComponent() {
            this.cashbookParsed.expenses.push({
                description: 'voeg omschrijving toe',
                amount: 0,
                instance: 'voeg instantie/aanbieder toe'
            });
            this.watchTrigger = true;
            this.updateCashBook();

            return;
        },
        deleteIncomeComponent(obj) {
            this.cashbookParsed.earnings.splice(
                this.cashbookParsed.earnings.indexOf(obj),
                1
            );
            this.watchTrigger = true;
            this.updateCashBook();

            return;
        },
        deleteExpenseComponent(obj) {
            this.cashbookParsed.expenses.splice(
                this.cashbookParsed.expenses.indexOf(obj),
                1
            );
            this.watchTrigger = true;
            this.updateCashBook();

            return;
        },
        updateCashBook() {
            const self = this;
            if (this.watchTrigger) {
                self.isProcessing = true;

                setTimeout(function() {
                    for (
                        let i = 0;
                        i <= self.cashbookParsed.earnings.length - 1;
                        i++
                    ) {
                        self.cashbookParsed.earnings[
                            i
                        ].amount = self.cashbookParsed.earnings[i].amount
                            .toString()
                            .replace(',', '.');
                    }

                    for (
                        let i = 0;
                        i <= self.cashbookParsed.expenses.length - 1;
                        i++
                    ) {
                        self.cashbookParsed.expenses[
                            i
                        ].amount = self.cashbookParsed.expenses[i].amount
                            .toString()
                            .replace(',', '.');
                    }

                    axios
                        .post('/clientdashboard/cashbook/update', {
                            earnings: self.cashbookParsed.earnings,
                            expenses: self.cashbookParsed.expenses
                        })
                        .finally(() => {
                            self.getCashBook();
                            self.watchTrigger = false;
                        });
                }, 250);
            }
        },
        getCashBook() {
            const self = this;
            axios
                .post('/clientdashboard/cashbook/get', {})
                .then(response => {
                    self.cashbookParsed = response.data.cashbook;
                    self.watchTrigger = false;
                })
                .finally(() => {
                    self.isProcessing = false;
                });
        },
        save() {
            this.watchTrigger = true;
            this.updateCashBook();
        },
        cancel() {},
        open() {},
        close() {}
    }
};
</script>

<style lang="scss">
.processing {
    &:before {
        content: '';
        width: 100%;
        height: 100%;
        background-color: rgba(#fff, 0.6);
        position: absolute;
    }
}

.processing-container {
    position: relative;
    overflow: hidden;
}

.cashbook .lds-ellipsis {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
button:disabled {
    opacity: 0.5;
}

.cashbook-pagination {
    margin-top: 30px;
}

.theme--light.v-pagination .v-pagination__item {
    border: 0 !important;
    border-radius: 50% !important;
    width: 30px;

    &.primary {
        background-color: $blue-7 !important; // I don't like Vuetify
    }
}
</style>
